/**
 * Coupon Popup — Imagine Dogs
 * - Abre automaticamente na primeira visita da sessão
 * - Countdown de N minutos (definido via data-minutes)
 * - Ao fechar, minimiza para badge fixo (canto inferior esquerdo) com o countdown rodando
 * - Clicar no badge reabre o popup
 * - Estado persiste durante a sessão via sessionStorage (não reabre sozinho de novo se já foi fechado)
 * - Quando o tempo zera, badge perde o countdown (sem reaproveitar urgência falsa)
 */

(function () {
  'use strict';

  function init() {
    var root = document.getElementById('coupon-popup-root');
    if (!root) return;

    var overlay = document.getElementById('coupon-popup-overlay');
    var closeBtn = document.getElementById('coupon-popup-close-btn');
    var badge = document.getElementById('coupon-popup-badge');
    var copyBtn = document.getElementById('coupon-popup-copy-btn');
    var clockEl = document.getElementById('coupon-popup-timer-clock');
    var badgeClockEl = document.getElementById('coupon-popup-badge-timer');

    var minutes = parseInt(root.getAttribute('data-minutes'), 10) || 15;
    var totalSeconds = minutes * 60;

    var STORAGE_KEY_DEADLINE = 'idogs_coupon_deadline_v2';
    var STORAGE_KEY_STATE = 'idogs_coupon_state'; // 'open' | 'minimized'

    var deadline = sessionStorage.getItem(STORAGE_KEY_DEADLINE);
    if (!deadline) {
      deadline = Date.now() + totalSeconds * 1000;
      sessionStorage.setItem(STORAGE_KEY_DEADLINE, deadline);
    } else {
      deadline = parseInt(deadline, 10);
    }

    var savedState = sessionStorage.getItem(STORAGE_KEY_STATE);

    function formatTime(secondsLeft) {
      var m = Math.floor(secondsLeft / 60);
      var s = secondsLeft % 60;
      return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }

    function getSecondsLeft() {
      return Math.max(0, Math.round((deadline - Date.now()) / 1000));
    }

    function showOverlay() {
      overlay.hidden = false;
      requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
      badge.hidden = true;
      sessionStorage.setItem(STORAGE_KEY_STATE, 'open');
      document.body.style.overflow = 'hidden';
    }

    function minimizeToBadge() {
      overlay.classList.remove('is-visible');
      setTimeout(function () {
        overlay.hidden = true;
      }, 250);
      badge.hidden = false;
      sessionStorage.setItem(STORAGE_KEY_STATE, 'minimized');
      document.body.style.overflow = '';
    }

    function tick() {
      var secondsLeft = getSecondsLeft();

      if (clockEl) clockEl.textContent = formatTime(secondsLeft);
      if (badgeClockEl) badgeClockEl.textContent = formatTime(secondsLeft);

      if (secondsLeft <= 0) {
        badge.classList.add('is-expired');
        clearInterval(intervalRef);
      }
    }

    var intervalRef = setInterval(tick, 1000);
    tick();

    // Estado inicial: se já foi minimizado nesta sessão, abre direto minimizado.
    // Se nunca interagiu, abre o popup automaticamente.
    if (savedState === 'minimized') {
      badge.hidden = false;
    } else {
      // pequeno delay para não disputar com o carregamento inicial da página
      setTimeout(showOverlay, 3000);
    }

    closeBtn.addEventListener('click', minimizeToBadge);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) minimizeToBadge();
    });

    badge.addEventListener('click', showOverlay);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) {
        minimizeToBadge();
      }
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            copyBtn.textContent = 'Copiado!';
            copyBtn.classList.add('is-copied');
            setTimeout(function () {
              copyBtn.textContent = 'Copiar';
              copyBtn.classList.remove('is-copied');
            }, 2000);
          });
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
